import {Dispatch, useCallback, useState} from 'react';

export const useToggleBoolean = (initialState: boolean) => {
  const [value, set] = useState(initialState);
  const toggle = useCallback(() => {
    set(!value);
  }, [value, set]);
  return [value, toggle, set] as [boolean, () => void, Dispatch<boolean>];
};
